<template>
  <div class="profile_top">
    <div class="profile_nav_title">
      <span></span>
      {{currentTitle}}
    </div>

    <div class="profile_nav_list">
      <el-radio-group v-model="currentRadio">
        <div v-show="radio=='我的上传'">
          <el-radio-button label="图书"></el-radio-button>
          <el-radio-button v-if="this.$store.state.user.roleName == '超级管理员'" label="教材"></el-radio-button>
          <el-radio-button label="试卷"></el-radio-button>
          <el-radio-button label="教案"></el-radio-button>
          <el-radio-button label="课件"></el-radio-button>
          <el-radio-button label="图片"></el-radio-button>
          <el-radio-button label="视频"></el-radio-button>
          <el-radio-button label="视频课程"></el-radio-button>
          <el-radio-button label="动画"></el-radio-button>
          <el-radio-button label="音频"></el-radio-button>
          <el-radio-button label="练习"></el-radio-button>
          <el-radio-button label="其他"></el-radio-button>
          <el-radio-button v-if="false" label="应用"></el-radio-button>
        </div>

        <div v-show="radio=='我的收藏'">
          <el-radio-button label="图书"></el-radio-button>
          <el-radio-button label="教材"></el-radio-button>
          <el-radio-button label="试卷"></el-radio-button>
          <el-radio-button label="教案"></el-radio-button>
          <el-radio-button label="课件"></el-radio-button>
          <el-radio-button label="图片"></el-radio-button>
          <el-radio-button label="视频"></el-radio-button>
          <el-radio-button label="视频课程"></el-radio-button>
          <el-radio-button label="动画"></el-radio-button>
          <el-radio-button label="音频"></el-radio-button>
          <el-radio-button label="练习"></el-radio-button>
          <el-radio-button label="其他"></el-radio-button>
          <el-radio-button v-if="false" label="应用"></el-radio-button>
        </div>

        <div v-show="radio=='设置信息'">
          <el-radio-button label="基本信息"></el-radio-button>
          <el-radio-button label="身份信息"></el-radio-button>
        </div>

        <div v-show="radio=='设置账户'">
          <el-radio-button label="账户绑定"></el-radio-button>
          <el-radio-button label="账户安全"></el-radio-button>
        </div>
      </el-radio-group>

    </div>

  </div>
</template>

<script>
export default {
  name: "ProfileTopNav",
  props: {
    radio: {
      type: String,
      default() {
        return "我的上传";
      },
    },
  },

  data() {
    return {
      currentRadio: "",
      currentTitle: "",
    };
  },

  created() {
    this._getCurrentRadio();
  },

  watch: {
    radio() {
      this._getCurrentRadio();
    },

    currentRadio(newValue) {
      // 顶部筛选
      switch (this.radio) {
        case "我的上传":
          this._goMyUpload(newValue);
          break;
        case "我的收藏":
          this._goMyCollection(newValue);
          break;
        case "设置信息":
          this._goSetInfo(newValue);
          break;
        case "设置账户":
          this._goSetAccount(newValue);
          break;
      }
    },
  },

  methods: {
    //前往我的上传页面--------------------------------------------
    _goMyUpload(name) {
      switch (name) {
        //我的收藏--------------------------------------------
        case "教材":
          this.$router.push({ name: "UpTextbook" });
          break;
        case "教案":
          this.$router.push({ name: "UpTeachingPlan" });
          break;
        case "试卷":
          this.$router.push({ name: "UpTestPaper" });
          break;
        case "应用":
          this.$router.push({ name: "UpApplication" });
          break;
        case "图书":
          this.$router.push({ name: "UpDigitalBooks" });
          break;
        case "课件":
          this.$router.push({ name: "UpCourseware" });
          break;
        case "图片":
          this.$router.push({ name: "UpPicture" });
          break;
        case "视频":
          this.$router.push({ name: "UpVideo" });
          break;
        case "视频课程":
          this.$router.push({ name: "UpVideoCourse" });
          break;
        case "动画":
          this.$router.push({ name: "UpAnimation" });
          break;
        case "音频":
          this.$router.push({ name: "UpAudio" });
          break;
        case "练习":
          this.$router.push({ name: "UpExercise" });
          break;
        case "其他":
          this.$router.push({ name: "UpOther" });
          break;
      }
    },

    //前往我的收藏页面--------------------------------------------
    _goMyCollection(name) {
      switch (name) {
        //我的收藏--------------------------------------------
        case "教材":
          this.$router.push({ name: "CoTextbook" });
          break;
        case "教案":
          this.$router.push({ name: "CoTeachingPlan" });
          break;
        case "试卷":
          this.$router.push({ name: "CoTestPaper" });
          break;
        case "应用":
          this.$router.push({ name: "CoApplication" });
          break;
        case "图书":
          this.$router.push({ name: "CoDigitalBooks" });
          break;
        case "课件":
          this.$router.push({ name: "CoCourseware" });
          break;
        case "图片":
          this.$router.push({ name: "CoPicture" });
          break;
        case "视频":
          this.$router.push({ name: "CoVideo" });
          break;
        case "视频课程":
          this.$router.push({ name: "CoVideoCourse" });
          break;
        case "动画":
          this.$router.push({ name: "CoAnimation" });
          break;
        case "音频":
          this.$router.push({ name: "CoAudio" });
          break;
        case "练习":
          this.$router.push({ name: "CoExercise" });
          break;
        case "其他":
          this.$router.push({ name: "CoOther" });
          break;
      }
    },

    //前往设置信息页面--------------------------------------------
    _goSetInfo(name) {
      switch (name) {
        //设置信息--------------------------------------------
        case "基本信息":
          this.$router.push({ name: "BasicInfo" });
          break;
        case "身份信息":
          this.$router.push({ name: "IdentityInfo" });
          break;
      }
    },

    //前往设置账户页面--------------------------------------------
    _goSetAccount(name) {
      switch (name) {
        //设置账户--------------------------------------------
        case "账户绑定":
          this.$router.push({ name: "AccountBind" });
          break;
        case "账户安全":
          this.$router.push({ name: "AccountSecurity" });
          break;
      }
    },

    //当前radio--------------------------------------------
    _getCurrentRadio() {
      switch (this.radio) {
        case "我的上传":
          this.currentRadio = "图书";
          this.currentTitle = "我的上传";
          break;
        case "我的收藏":
          this.currentRadio = "图书";
          this.currentTitle = "我的收藏";
          break;

        case "设置信息":
          this.currentRadio = "基本信息";
          this.currentTitle = "账户设置";
          break;

        case "设置账户":
          this.currentRadio = "账户绑定";
          this.currentTitle = "账户设置";
          break;
      }
    },
  },
};
</script>

<style lang='less' scoped>
.profile_nav_title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 20px;

  span {
    width: 4px;
    height: 16px;
    background-color: #24ba58;
    border-radius: 4px;
    margin-right: 10px;
  }
}
.profile_nav_list {
  // 按钮UI样式修改
  .el-radio-group {
    display: flex;
    color: #333333;

    /deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background-color: #24ba58;
      box-shadow: -1px 0 0 0 #24ba58;
    }

    /deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner:hover {
      color: #fff;
    }

    /deep/.el-radio-button__inner:hover {
      background-color: #e9f5ed;
      color: #333;
    }

    /deep/.el-radio-button__inner {
      font-size: 12px;
      font-weight: 400;
      font-family: Microsoft YaHei;
      border: 0;
      text-align: start;
      border-radius: 3px;
    }
  }
}
</style>